<template lang="es">
  <v-app>
    <div>
      <div>
        <div class="mb-4 mt-2 pl-3 pr-3">
          <v-row class="justify-center">      
            <v-col cols="8" md="2">
              <v-menu v-model="fechaInicioInput" :close-on-content-click="true" 
                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedDate"
                    label="Fecha Inicio"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker locale = "es-ES" first-day-of-week="1" v-model="selectedDate" @input="updateDate = false"></v-date-picker>                       
              </v-menu>
            </v-col> 
            <v-col cols="1">
              <v-btn color="primary" @click="fetchHistoricalData">Buscar</v-btn>
            </v-col> 
          </v-row>
        </div> 

        <!-- Leyenda Gráfica -->
        <v-card>
          <v-layout class="mt-1">
            <v-flex xs12>
              <div v-if="!loadingData" class="line-chart-secadero">
                <line-chart-nuevo :chartData="chartDataComputed" :chartOptions="chartOptions" :baseLineValue="baseLineValue" ref="lineChartNuevo"></line-chart-nuevo>
              </div>
              <div v-else class="loading-spinner">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <span>Cargando datos...</span>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
        
        <!-- Mensaje si no hay datos -->
        <div v-if="!loadingData && noDataMessage" class="no-data-message">
          <p>No hay datos disponibles</p>
        </div>

        <!-- Tabla de Datos Históricos -->
        <v-card>
          <v-card-title>
            Datos Históricos
            <v-spacer></v-spacer>
            <v-btn @click="guardarCsv()">Descargar</v-btn>
          </v-card-title>
          
          <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            :items-per-page="10"
            class="elevation-1"
          >
          </v-data-table>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import LineChartNuevo from '@/components/LineChartNuevo.vue';
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  components: {
    LineChartNuevo
  },
  props: {
    client: Object
  },
  data() {
    return {
      loadingData: false,
      noDataMessage: false, // Nueva propiedad para el mensaje
      fechaInicioInput: false,
      selectedDate: moment().format('YYYY-MM-DD'),
      baseLineValue:0,
      chartData: {
        datasets: [
          {
            id: "temperatura_trabajo",
            label: "Temperatura trabajo",
            data: [],
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0,
            yAxisID: 'y'
          },
          {
            id: "temperatura_horno",
            label: "Temperatura horno",
            data: [],
            borderColor: "rgba(255, 99, 132, 1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0,
            yAxisID: 'y2'
          },
          {
            id:"velocidad_sinfines",
            label: "Velocidad sinfines alimentadores",
            data: [],
            borderColor: "rgba(0, 102, 204, 1)",
            backgroundColor: "rgba(0, 102, 204, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y3'

          },
          {
            id:"temperatura_quemador",
            label: "Temperatura trabajo quemador",
            data: [],
            borderColor: "rgba(255, 255, 0, 1)",
            backgroundColor: "rgba(255, 255, 0, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y'

          },
        ]
      },
      chartOptions: {
        
      },
      tableData: [],
      tableHeaders: [
        { text: 'Fecha', value: 'timestamp' },
        { text: 'Temperatura Trabajo (ºC)', value: 'temperaturaTrabajo' },
        { text: 'Temperatura Horno (ºC)', value: 'temperaturaHorno' },
        { text: 'Velocidad Sinfines Alimentadores (Hz)', value: 'velocidadSinfines'},
        { text: 'Tº Trabajo Quemador (ºC)', value: 'temperaturaQuemador'}
      ],
    }
  },
  methods: {
    ...mapActions("nodered",['doSubscribe']),
    ...mapActions(["getData"]),

    updateDate(date) {
      this.selectedDate = date;
    },
    async fetchBaseLineValue() {
      try {
        // Llama a la API para obtener el valor de la base de datos
        const payload = { 
          path: 'secadero/variables/baseLineaValue',
        };
        const response = await this.getData(payload);
        if (response.ok) {
          const baseLineFromDB = parseFloat(response.results.rows[0].valor);
          if (!isNaN(baseLineFromDB)) {
            this.baseLineValue = baseLineFromDB; // Asigna el valor recuperado
            this.horizontalLineValue = baseLineFromDB; 
          }
        } else {
          console.error('Error al obtener el valor desde la base de datos:', response.error);
        }
      } catch (error) {
        console.error('Error al obtener el valor desde la base de datos:', error);
      }
    },
    async fetchVariableSettings() {
    try {
      // const response = await axios.get(`/variables/plc/${this.plc_id}`);
      const payload = {
        path:`secadero/variables/plc/${this.plc_id}`,
        params: {}
      }
      const response =  await this.getData(payload);
      
      if (response.ok) {
        const variables = response.variables;
        // Asigna `precision` a cada dataset en chartData según su `id`
        variables.forEach(variable => {
          const dataset = this.chartData.datasets.find(ds => ds.id === variable.memory);
          if (dataset) {
            dataset.precision = variable.precision ; 
          }
        });
      }
    } catch (error) {
      console.error("Error al obtener configuraciones de variables:", error);
    }
  },
    async fetchHistoricalData() {

      this.fetchBaseLineValue();
      this.loadingData = true;
      this.noDataMessage = false; // Reiniciar el mensaje al buscar datos
      const selectedDate = new Date(this.selectedDate);
      const firstDay = new Date(selectedDate);
      firstDay.setHours(6, 0, 0, 0);
      const lastDay = new Date(selectedDate);
      lastDay.setDate(selectedDate.getDate() + 1);
      lastDay.setHours(6, 0, 0, 0);

      try {
        const payload = {
          path: "secadero/variables/history",
          params:{ firstDay, lastDay }
        }
        const response = await this.getData(payload);
        if (response.ok) {
          const historicalData = response.results;
            //ordenamos datos
          historicalData.sort((a, b) => new Date(a.real_timestamp) - new Date(b.real_timestamp));
            //limpiamos anteriores datos
          this.chartData.datasets.forEach(dataset => {
            dataset.data = [];
          });
          this.tableData = [];
          
          if (historicalData.length === 0) {
            this.noDataMessage = true; // No hay datos disponibles
          } else {
            historicalData.forEach(item => {
              console.log(item)
              const timestamp = moment(item.real_timestamp).format('YYYY-MM-DD HH:mm:ss');
              const temperaturaTrabajo = parseFloat(item.temperatura_trabajo).toFixed(2);
              const temperaturaHorno = parseFloat(item.temperatura_horno).toFixed(2);
              const velocidadSinfines = parseFloat(item.velocidad_sinfines).toFixed(2);
              const temperaturaQuemador = parseFloat(item.temperatura_quemador).toFixed(2);
              this.tableData.push({ timestamp, temperaturaTrabajo, temperaturaHorno, velocidadSinfines, temperaturaQuemador });
              // Agregar datos a los datasets del gráfico
              this.chartData.datasets[0].data.push({ x: timestamp, y: temperaturaTrabajo });
              this.chartData.datasets[1].data.push({ x: timestamp, y: temperaturaHorno });
              this.chartData.datasets[2].data.push({ x: timestamp, y: velocidadSinfines });
              this.chartData.datasets[3].data.push({ x: timestamp, y: temperaturaQuemador });
            });
          }
        } else {
          this.noDataMessage = true; // No hay datos disponibles
        }
      } catch (error) {
        console.error("Error al obtener datos históricos:", error);
      } finally {
        this.loadingData = false;
      }
    },

    // Método para descargar los datos históricos en formato CSV
    guardarCsv() {
      const csvContent = "data:text/csv;charset=utf-8," + this.tableData.map(item => {
        return [
          item.timestamp,
          item.temperaturaTrabajo,
          item.temperaturaHorno,
          item.velocidadSinfines,
          item.temperaturaQuemador
        ].join(",");
      }).join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.selectedDate+"_secadero.csv");
      document.body.appendChild(link);
      link.click();
    },
  },

  computed: {
    chartDataComputed() {
      return this.chartData;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.display-1 {
  text-align: center;
  margin-top: 10px;
}
.line-chart-secadero {
  width: 95%; 
  height: 300px;
  margin: 2%;
  margin-bottom: 120px;
}
.v-data-table {
  margin-top: 100px;
}
.no-data-message {
  text-align: center;
  margin: 20px;
  font-weight: bold;
  color: red; /* Puedes cambiar el color si lo deseas */
}
</style>
